module.exports = __webpack_public_path__ + "static/img/indexBanner.8b0b925b.png";